import * as cronstrue from "cronstrue/i18n";
import moment from "moment-timezone";
import { Alert } from "react-bootstrap";
import { Link } from "react-router";

import { useLocationDocument } from "../../api/firestoreWrappers.generated.jsx";
import urls from "../../urls.jsx";
import TimeDisplay from "../TimeDisplay";

export function getRoutineDescription({
    routine,
    routineTask,
    routineMission,
    location,
}) {
    const cronDescription = cronstrue
        .toString(routine?.interval, {
            throwExceptionOnParseError: false,
            locale: "en",
            use24HourTimeFormat: true,
            verbose: true,
        })
        .toLowerCase();

    const userTimezone = moment.tz.guess();
    const localTimezone = location?.timezone;
    const showTimezone =
        localTimezone !== undefined && localTimezone !== userTimezone;
    const timezoneInfo = showTimezone ? ` in timezone '${localTimezone}'` : "";
    const droneText =
        routine?.droneId !== "ANY" ? `drone ${routine?.droneId}` : "any drone";

    const text =
        `Start task ${routineTask?.name} ${cronDescription}${timezoneInfo} on ${droneText}` +
        (routineMission
            ? `, continuing with mission at ${moment.unix(routineMission.timestamp.seconds).format("YYYY-MM-DD HH:mm:ss")}`
            : "");

    const normalDroneSection = (
        <>
            {" "}
            on drone{" "}
            <Link
                to={urls.locationDrone(
                    routine?.organizationId,
                    routine?.locationId,
                    routine?.droneId,
                )}
            >
                {routine?.droneId}
            </Link>
        </>
    );
    const anyDroneSection = <> on any drone </>;

    const jsx = (
        <>
            Start task{" "}
            <Link
                to={urls.task(
                    routine?.organizationId,
                    routine?.locationId,
                    routineTask?.id,
                )}
            >
                {routineTask?.name}
            </Link>{" "}
            {cronDescription}
            {timezoneInfo}
            {routine?.droneId !== "ANY" ? normalDroneSection : anyDroneSection}
            {routineMission && (
                <>
                    , continuing with mission{" "}
                    <Link
                        to={urls.locationMission(
                            routine?.organizationId,
                            routine?.locationId,
                            routineMission.id,
                        )}
                    >
                        {
                            <TimeDisplay
                                timestamp={routineMission.timestamp.seconds}
                                format="YYYY-MM-DD HH:mm:ss"
                                organizationId={routine?.organizationId}
                                locationId={routine?.locationId}
                            />
                        }
                    </Link>
                </>
            )}
        </>
    );

    return { text, jsx };
}

export default function RoutinePreview({
    routine,
    location: providedLocation,
    routineTask,
    routineMission,
    className,
}) {
    // When a location is already provided, we pass undefined to our hook which disables it effectively
    const [localLocation] = useLocationDocument(
        providedLocation ? undefined : routine?.organizationId,
        providedLocation ? undefined : routine?.locationId,
    );

    // Prefer our providedLocation over our localLocation
    const location = providedLocation ?? localLocation;

    const { jsx: descriptionJSX } = getRoutineDescription({
        routine,
        routineTask,
        routineMission,
        location,
    });

    return (
        <Alert variant="primary" className={className}>
            {descriptionJSX}
        </Alert>
    );
}
